import { QUOTAS } from "../../../../../consts";

// Sentence case, per the handoff's row table — not the pluralising labels
// QuotaLabelMapping/the old LabelMapping used, and not Title Case.
export const QUOTA_LABELS = {
  [QUOTAS.domains]: "Website domains",
  [QUOTAS.team]: "Team members",
  [QUOTAS.integrations]: "Integrations",
  [QUOTAS.widgets]: "Published widgets",
  [QUOTAS.views]: "Widget views",
  [QUOTAS.events]: "Synced events",
  [QUOTAS.eventsMonthsAhead]: "Future events pulled",
};

// Only these two quotas reset monthly (see handoff table); absence of the
// qualifier is what marks the other rows as standing/permanent limits.
export const MONTHLY_RESET_QUOTAS = new Set([QUOTAS.views, QUOTAS.events]);

// No existing "near ceiling" threshold in the codebase (checked plan/quota
// helpers in tools.js and subscription.js — they're binary allow/deny).
// Single source of truth for both the bar colour and the badge so they can
// never disagree.
export const NEAR_LIMIT_THRESHOLD = 0.75;

/**
 * @param {number} usage
 * @param {number} quota
 * @returns {"room"|"near"|"full"}
 */
export function getQuotaLevel(usage, quota) {
  if (!(quota > 0)) return "room";
  const used = usage || 0;
  if (used >= quota) return "full";
  if (used / quota >= NEAR_LIMIT_THRESHOLD) return "near";
  return "room";
}

const MONTH_ABBR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * The next monthly reset — the 1st of the following month, computed from
 * today. Not a stored renewal/billing date (no such field exists on the
 * organization/subscription model).
 * @param {Date} [from]
 * @returns {string} e.g. "1 Sep 2026"
 */
export function getNextMonthlyReset(from = new Date()) {
  const next = new Date(from.getFullYear(), from.getMonth() + 1, 1);
  return `1 ${MONTH_ABBR[next.getMonth()]} ${next.getFullYear()}`;
}

export function formatNumber(n) {
  return Intl.NumberFormat(window.navigator.language || "en-US").format(n);
}
